import { htmlSafe } from '@ember/template';
import Ember from 'ember';

const escapeExpression = (Ember as unknown as { Handlebars: { Utils: { escapeExpression: (str: string) => string } } })
  .Handlebars.Utils.escapeExpression;

const escapeRegExp = (value: string): string => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

export default function highlightText(text: string, searchQuery: string): ReturnType<typeof htmlSafe> {
  // String(...) forces a primitive even for SafeString input, so it can never bypass escaping below.
  const source = String(text ?? '');

  if (!searchQuery || !text) {
    return htmlSafe(escapeExpression(source));
  }

  // Split the raw text on the query and escape each segment independently. Matching the raw text (not the
  // escaped text) avoids highlighting inside an escape-generated entity, and escaping per segment keeps
  // <mark> the only trusted markup. Capturing-group split interleaves matches at odd indices.
  const regex = new RegExp(`(${escapeRegExp(String(searchQuery))})`, 'gi');
  const highlightedText = source
    .split(regex)
    .map((segment, index) => {
      const escaped = escapeExpression(segment);
      return index % 2 === 1 ? `<mark class="bg-pistachio-10 rounded">${escaped}</mark>` : escaped;
    })
    .join('');

  return htmlSafe(highlightedText);
}
